$(document).ready(function(){
    $('form[action="/cart/add"], form[action="/da/cart/add"], form[action="/de/cart/add"]').submit(function (e) {
        e.preventDefault();
        var $addToCartForm = $(this);
        var $addToCartBtn = $addToCartForm.find(".add-to-cart-btn");
        $addToCartBtn.parent().addClass("loading");
        $(".add-to-cart-btn").addClass("disabled").prop("disabled", true);
        var product_form_ID = $(this).attr("id");
        var thisForm = $(this);
        var id = $(this).find('[name="id"]').val();
        var quantity = +$(this).find('[name="quantity"]').val();
        window.setTimeout(function () {
          $addToCartBtn.parent().removeClass("loading");
          $(".add-to-cart-btn")
            .prop("disabled", false)
            .removeClass("disabled")
            .removeClass("inverted");
          //_setText($addToCartBtn,_config.addToCartBtnLabel);
        }, 1700);
        if ($("#upsell-list").length > 0) {
          var prod_id_array = product_form_ID.split("_");
          var prod_id = prod_id_array[2];
          var csItem = "#cs-item-" + prod_id;
  
          if ($(window).width() < 768) {
            $("#upsell-list").find(csItem).fadeOut();
            window.setTimeout(function () {
              var slideIndex = $("#upsell-list").find(csItem).data("slick-index");
              $(".cross-sell-carousel").slick("slickRemove", slideIndex);
              //$('.cross-sell-carousel').slick('refresh');
            }, 2000);
          } else {
            $("#upsell-list").find(csItem).slideUp();
          }
        }

        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            data: thisForm.serialize(),
            dataType: 'json',            
            success: function(data) {
                 window.location.href = '/cart';
            //     if(productList.length > 0 && $('.free-gift-form').length > 0 ) {
            //         let prodCount = productList.length;
            //         for (let i = 0; i < productList.length; i++) {
            //             if(productList[i] == id){
            //                 pdp_free_prod_atc();
            //             } else {
            //                 get_cart_details();
            //             }
            //         }
            //     } else {
            //         get_cart_details();

            //     }
            //   $('body').addClass('cartShown'); 
            },
            error: function(err){

                 // console.log('error');
            }
        });
    });

    function get_cart_details(){
        fetchCall();
    };
    function pdp_free_prod_atc() {
        $.ajax({
            type: 'POST', 
            url: '/cart/add.js',
            dataType: 'json', 
            data: $('.free-gift-form').serialize(),
            success: function(data) {
                $('.header-top').addClass('free-product-in-cart');
                get_cart_details();
            },
            error: function(data) {
                // get_cart_details();
            },
        });
    }

    setTimeout(function() {
    $.getJSON('/cart.js', function(cart) {
        var cartItems = cart.items;
        if( cartItems == 0) {
            $('.cart-item-wrap').html('<div class="empty-cart-content"><h3>YOUR CART IS EMPTY</h3> <div class="empty-cart-btn"><a href="/" class="btn bg-dark-blue">SHOP</a></div></div>');
        }
        });
    }, 10); 



    $(document).on("keyup change", "[data-quantity-updates]", function () {
        var $input = $(this);
        changeQty($input);
    });

    // $(document).on("click", ".order-remove-btn", function (e) {
    //     itemRemove(e, $(this));
    // });
    // $(document).on("click", ".modplus", function (e) {
    //     increaseItem(e, $(this));
    // });
    // $(document).on("click", ".modminus", function (e) {
    //     decreaseItem(e, $(this));
    // });
});

function fetchCall() {
    $.getJSON('/cart.js', function(cart) {
        fetch('/?section_id=header')
        .then(response => response.text())
        .then(cartData => {
            var cart_html = $(cartData),
            cart_items = $('.cart-onorder-item-wrap' , cart_html),
            cart_header = $('.cart_header' , cart_html),
            cart_count = $('.order-title',cart_html).eq(0),
            cart_content = $('.cart-content-inner',cart_html).eq(0),
            totalPrice = $('.cart-total-price',cart_html);
            
            $('.cart-onorder-item-wrap').replaceWith(cart_items);
            $('.cart_header').replaceWith(cart_header);
            $('.order-title').replaceWith(cart_count);
            $('.cart-content-inner').replaceWith(cart_content);
            $('.cart-total-price').replaceWith(totalPrice);

            if ($('.free-shipping-bar-wrapper').length > 0 ) {
                var shippingBar = $('.free-shipping-bar-wrapper',cart_html),
                shippingMessage = $('.free-shipping-message',cart_html);
                $('.free-shipping-message').replaceWith(shippingMessage);
                var newProgress = $(shippingBar).data('progress');
                if( newProgress >= 100){
                    newProgress = 100; 
                    $('.free-shipping-bar-wrapper').addClass('free-shipping-enabled');
                } else {
                    $('.free-shipping-bar-wrapper').removeClass('free-shipping-enabled');
                }
                $('.free-shipping-bar-inner').css('width',newProgress+'%');
                $('.free-shipping-bar-wrapper').attr('data-progress',newProgress);
            }

        });
    });
}

// increase item 
function increaseItem(e, el){   
    var $input = el.previousElementSibling,
    max = $input.max,
    id = $input.data-id,
    //value = parseInt($input.val());
    value = parseInt($input.value);

    if (value < max) {
        value = value + 1;
    } else {
        let errorMsg =
        "Sorry, we don't have more than " + max + " in stock at the moment";
        $("#" + id + " .cart-item-error-msg").html(errorMsg);
        $("#" + id + " .cart-item-error-msg").slideDown();
        setTimeout(function () {
        $("#" + id + " .cart-item-error-msg").slideUp();
        }, 5000);
    }     
    $input.value = value
    changeQty($input);
};

// decrease item 
function decreaseItem(e , el){
    var $input = el.nextElementSibling,
    value = parseInt($input.value);
    if (value > 1) {
        value = value - 1;
    } else {
        value = 0;
        itemRemove(e,el);
    }  
    $input.value = value;
    changeQty($input);
};

// itme remove 
function itemRemove(e, el){
    e.preventDefault();
    $.getJSON('/cart.js', function(cart) {
        var id = parseFloat($(el).data('id')); 
        var data = { updates: {} };
        data.updates[id] = '0';
        let updateFreeQty = 0;
        if($('.free-product-in-cart').length > 0 && $('.free-gift-form').length > 0) {
            let removeAmount = 0;
            let currentAmount = 0;
             for (let i = 0; i < cart.items.length; i++) {
                cartItemID = cart.items[i].id;
                if(cartItemID == id) {
                    for (let p = 0; p < productList.length; p++) {
                        if(productList[p] == id){
                            removeAmount = removeAmount + cart.items[i].quantity;
                        }
                    }
                }
                if(cartItemID == giftVariantID) {
                    currentAmount = cart.items[i].quantity;
                }
             }
             updateFreeQty = currentAmount - removeAmount <= 0 ? 0 : currentAmount - removeAmount;
            // let freeProdID = $('.free-product-in-cart').data('freeprodid');
            data.updates[giftVariantID] = updateFreeQty;
        }
        
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            dataType: "json",
            data: data
        }).then((data) => {
            fetchCall();
            if(updateFreeQty <= 0 ){
                $('.header-top').removeClass('free-product-in-cart');
            }
        });
    });
};

function changeQty($input){      
    $.getJSON('/cart.js', function(cart) {   
        var variant_id= $($input).data("id"),
        value = $($input).val(),         
        data = { updates: {} };
        data.updates[variant_id] = value;

        if($('.free-product-in-cart').length > 0) {
            let removeAmount = 0;
            let currentAmount = 0;
            let updateFreeQty = 0;
            for (let i = 0; i < cart.items.length; i++) {
                cartItemID = cart.items[i].id;
                for (let p = 0; p < productList.length; p++) {
                    if(productList[p] == cartItemID){
                        if(cartItemID == variant_id) {
                            // this is to cater for the changed value
                            updateFreeQty = updateFreeQty + parseInt(value);
                        } else {
                            updateFreeQty = updateFreeQty + cart.items[i].quantity;
                        }
                    }
                }
            }
            data.updates[giftVariantID] = updateFreeQty;
            console.log('giftVariantID',giftVariantID);
            console.log('updateFreeQty',updateFreeQty);
        }


        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(res) {  
                fetchCall();
            },
            error:function(err){
                    // console.log('error');
            }
        });
    });
};


$(".new-atc-btn").on("click", function (e) {
  e.preventDefault();
  formData = $(this).next(".new-btn-form").serialize();
  addToCart(formData)
});

function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
    //   $("body").addClass("cart-expand");
    //   $("body").addClass("cart-upsell-expand");
    // $('body').addClass('cartShown'); 
    $('.cart-content-inner').trigger('click');
      fetchCall();
      // sectionRedering();

    },
    error: function (err) {
      console.log(err);
    },
  });
};











// new cart


function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeCartItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      sectionRedering();
    }
  })
}



function sectionRedering() {
    var sectionId = $('.cart-page__inner').attr('data-section-id');
  fetch("/cart?section_id=" + sectionId)
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-page__product-wrap", cart__html);
      $(".cart-page__product-wrap").replaceWith(render__html);

      var render__html = $(".cart-page__top", cart__html);
      $(".cart-page__top").replaceWith(render__html);

      var render__html = $(".cart-page__right", cart__html);
      $(".cart-page__right").replaceWith(render__html);
    });

  // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var header__html = $(data);
      var renderHeader__html = $(".cart-content .cart-counter", header__html);
      $(".cart-content .cart-counter").replaceWith(renderHeader__html);
    });

}